import { ref, computed } from 'vue';
import { useDevice } from '@modules/discovery/composables';
import useExperimentIds from '@composables/useExperimentIds';
import { deviceProductsPerRow } from '@utils/constants';
import usePageType from '@modules/discovery/composables/usePageType';
import useEnvParams from '@composables/useEnvParams';

const desktopAlt = '2561-21'; // alt grid view for desktop, default 6 ppr (products per row) can switch to 4 ppr
const phoneAlt1 = '2562-21'; // alt grid view for phone, default 3 ppr can switch to 2 ppr
const phoneAlt2 = '2562-22'; // alt grid view for phone portrait, default 1 ppr row can switch to 2 ppr
const controlAlt = '2665-21'; // control opt in for mcom only - desktop default 4 ppr can switch to 6 ppr, phone default 2 ppr can switch to 1 ppr

export default function useAltGridViewExperimentation() {
  const { isSearch } = usePageType();
  const { deviceType } = useDevice();
  const { experimentIds } = useExperimentIds();
  const { isMcom } = useEnvParams();

  const desktopAltEnabled = ref(false);
  const phoneAltEnabled1 = ref(false);
  const phoneAltEnabled2 = ref(false);
  const controlAltDesktopEnabled = ref(false);
  const controlAltPhoneEnabled = ref(false);

  if (!isSearch) {
    desktopAltEnabled.value = experimentIds.value.includes(desktopAlt) && deviceType !== 'PHONE';
    phoneAltEnabled1.value = experimentIds.value.includes(phoneAlt1) && deviceType === 'PHONE';
    phoneAltEnabled2.value = experimentIds.value.includes(phoneAlt2) && deviceType === 'PHONE';
  }
  controlAltDesktopEnabled.value = experimentIds.value.includes(controlAlt) && deviceType !== 'PHONE' && isMcom;
  controlAltPhoneEnabled.value = experimentIds.value.includes(controlAlt) && deviceType === 'PHONE' && isMcom;

  const altGridViewEnabled = computed(() => desktopAltEnabled.value || phoneAltEnabled1.value || phoneAltEnabled2.value
    || controlAltDesktopEnabled.value || controlAltPhoneEnabled.value);

  const noOfDesktopProds = computed(() => (desktopAltEnabled.value ? deviceProductsPerRow.DESKTOPALT : deviceProductsPerRow.DESKTOP));
  const noOfPhoneProds = computed(() => {
    if (phoneAltEnabled1.value) {
      return deviceProductsPerRow.PHONEALT1;
    } if (phoneAltEnabled2.value) {
      return deviceProductsPerRow.PHONEALT2;
    }
    return deviceProductsPerRow.PHONE;
  });

  return {
    altGridViewEnabled,
    noOfDesktopProds,
    noOfPhoneProds,
    desktopAltEnabled,
    phoneAltEnabled1,
    phoneAltEnabled2,
    controlAltDesktopEnabled,
    controlAltPhoneEnabled,
  };
}
